import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@mui/material"
import {ExpandMore as ExpandMoreIcon, AddBox as AddBoxIcon} from "@mui/icons-material"
import React from "react"

import {CustomerPhoneUpdateActivityPayload, CustomerPhoneUpdateByCustomerActivityPayload} from "@indebted/api"

function PhoneAddedActivity(
	panelId: number,
	{
		Title,
		HappenedAt,
		Payload,
	}: {
		Title: string
		HappenedAt: string
		Payload: CustomerPhoneUpdateActivityPayload | CustomerPhoneUpdateByCustomerActivityPayload
	},
	expanded: boolean,
	handleExpand: (panelID: number) => (event: any, isExpanded: boolean) => void,
	classes: {summary: string; activityContent: string; activityContentLabel: string; activityContentValue: string},
) {
	return (
		<Accordion expanded={expanded} onChange={handleExpand(panelId)}>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<AddBoxIcon color="primary" />
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
			</AccordionSummary>
			<AccordionDetails>
				{expanded && (
					<div className={classes.activityContent}>
						<div>
							<Typography className={classes.activityContentLabel}>Phone:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.Phone}</Typography>
						</div>
					</div>
				)}
			</AccordionDetails>
		</Accordion>
	)
}

export {PhoneAddedActivity}
